import type { ApolloCache } from "@apollo/client/cache"

import { FloorCompleteFragment } from "entities/floors/graphql/fragments.generated"
import { readFloorCompleteFragment } from "entities/floors/lib/readFloorFragment"
import { ProductPositionFragment } from "entities/product-positions/graphql/fragments.generated"
import { readProductPositionFragment } from "entities/product-positions/lib/readProductPositionFragment"
import { RoomCompleteFragment } from "entities/rooms/graphql/fragments.generated"
import { readRoomCompleteFragment } from "entities/rooms/lib/readRoomFragment"

/**
 * Attempts to read a Floor, Room, or ProductPosition fragment from the cache.
 * Tries each type in order and returns the first one found.
 *
 * @param id - The ID of the child entity
 * @param cache - Apollo cache instance
 * @returns The child fragment (Floor, Room, or ProductPosition) or null if not found
 */
export function readProjectChildFragment(
  id: string,
  cache: ApolloCache<object>
):
  | FloorCompleteFragment
  | RoomCompleteFragment
  | ProductPositionFragment
  | null {
  const floor = readFloorCompleteFragment(id, cache)
  if (floor) {
    return floor
  }

  const room = readRoomCompleteFragment(id, cache)
  if (room) {
    return room
  }

  const productPosition = readProductPositionFragment(id, cache)
  if (productPosition) {
    return productPosition
  }

  return null
}
